import { RHs } from 'utils/helpers/dictionaries';

export const RHList: RHs[] = [
  RHs.rh_negative,
  RHs.rh_positive
]
